import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import WidgetComponent from '@/components/Widget'

import Container from './style'

interface Props {
  symbol: ReactNode
  title: string
  children: ReactNode | string
  style?: CSSProperties
  className?: string
  id?: string
}

function Widget({
  id,
  className,
  style,
  symbol,
  title,
  children,
}: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <WidgetComponent>
        <figure className="symbol-container">{symbol}</figure>
        <h1>{title}</h1>
        <p>{children}</p>
      </WidgetComponent>
    </Container>
  )
}

Widget.propTypes = {
  symbol: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

Widget.defaultProps = {
  className: '',
}

export default memo(Widget)
